<div class='footer1 py-5'>
  <div class='container'>
    <div class=' justify-content-center'>
      <div class=''>
        <h2 class='text-center fs-2 mb-5 mb-lg-3 '>Get the Latest Deals, Insights & Updates <br class="d-none d-md-block"> – Subscribe to Our Newsletter Today!</h2>
      </div>

      <div class='mx-0 px-0 text-center d-flex align-items-center justify-content-center '>
        <form class='' #subscribeForm="ngForm" >
          <input ngModel placeholder='Full Name*' name="name" type='text' class='col-4 col-md-2 mx-2 col-lg-3 px-3 me-lg-2  fs-3 ' required/>
          <input ngModel placeholder='Email*' name="email" type='email' class='col-4 col-md-2 mx-2 col-lg-3 px-3 me-lg-2 fs-3 ' required/>

          <button type='Submit' class=' mt-4 mt-md-0 fs-5 ' (click)="onSubscription(subscribeForm.value)">Subscribe</button>
        </form> 
      </div>
    </div>
  </div>
</div>
